import React from "react";
import { useParams } from "react-router-dom";

import { useAccountContracts } from "@/api/queries/contracts";
import LoadingWrapper from "@/components/loading-wrapper";

import { ACCOUNT_ID_PARAM } from "..";
import { Table } from "../../components/Table";
import { CONTRACTS_COLUMNS } from "../../config/contractsTable";

export function AccountContracts() {
  const { accountId } = useParams<{
    [ACCOUNT_ID_PARAM]: string;
  }>();

  const { data, isLoading, error } = useAccountContracts(Number(accountId));

  return (
    <LoadingWrapper
      loading={isLoading}
      loadingLayout="table"
      errorText={error && "There was an issue loading the account contracts"}
    >
      <Table
        rows={data?.contracts}
        columns={CONTRACTS_COLUMNS}
        addRowText="Add New Contract +"
      />
    </LoadingWrapper>
  );
}
